var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldStar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#EDA600",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.76 10.28-5.56 4 2.12 6.53a.47.47 0 0 1-.18.55.46.46 0 0 1-.29.1.49.49 0 0 1-.3-.1l-5.55-4-5.55 4a.49.49 0 0 1-.59 0 .47.47 0 0 1-.18-.55l2.12-6.49-5.56-4a.52.52 0 0 1-.18-.56.51.51 0 0 1 .48-.34H9.4l2.12-6.53a.52.52 0 0 1 1 0l2.08 6.49h6.86a.51.51 0 0 1 .48.34.52.52 0 0 1-.18.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStar2);
export default __webpack_public_path__ + "static/media/gold-star-2.594870857a4c198c0744d3c9a40a9cb5.svg";
export { ForwardRef as ReactComponent };